import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import {RouteInfos} from "../features/models/routeInfos.model";
import { AuthService } from '../features/components/auth/auth.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {
    
    model: RouteInfos[] = [];

    constructor(private authService: AuthService) {
    }

    ngOnInit() {
        this.model = [
            {
                label: 'Tableau de bord',
                icon: 'pi pi-home',
                authorities: [],
                items: [
                    {
                        label: 'Accueil',
                        icon: 'pi pi-fw pi-home',
                        routerLink: ['/'],
                        authorities: [],
                    },
                ]
            },
            {
                label: 'Métiers',
                icon: 'pi pi-home',
                authorities: ['USER', 'ADMIN', 'ROLE_PUBLICATION'],
                items: [
                    {
                        label: 'Articles',
                        icon: 'pi pi-file',
                        routerLink: ['/articles'],
                        authorities: ['ROLE_PUBLICATION', 'ADMIN'], 
                    },
                    {
                        label: 'Catégories',
                        icon: 'pi pi-building',
                        routerLink: ['/categories'],
                        authorities: ['ADMIN'],
                    },
                  {
                    label: 'Sous Catégories',
                    icon: 'pi pi-id-card',
                    routerLink: ['/sous-categorie'],
                    authorities: ['ADMIN'],
                  },

                  
                ]
            },
            ...(this.authService.hasAnyAuthority(['ADMIN']) ?
                [     
                    {
                        label: 'Paramètres',
                        icon: 'pi pi-cog',
                        authorities: ['ADMIN'],
                        items: [
                                {
                                    label: 'Profils',
                                    icon: 'pi pi-flag',
                                    routerLink: ['/users/profils'],
                                    authorities: [],
                                },
                                {
                                    label: 'Utilisateurs',
                                    icon: 'pi pi-users',
                                    routerLink: ['/users'],
                                    authorities: [],
                                },
                        ]
                    }
                ] : []
            ),
        ];
    }
}
